module.exports = {
  title: 'Duration Slider with React Native Skia 🕒',
  author: 'Enzo Manuel Mangano',
  date: '2024-09-10',
  slug: 'duration-slider',
  tags: ['skia'],
};
